import type { FirebaseApp } from "firebase/app";

export class Firestore {
  static appInstance: FirebaseApp;

  static setAppInstance(instance: FirebaseApp) {
    Firestore.appInstance = instance;
  }
}
